<template>
	<slot :open="isOpen" :toggleOpen="toggle"></slot>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'
import {  generateGridHashMarkBounds } from "@js/grid.js";

const isOpen = ref(false);

const toggle = () => {
	isOpen.value = !isOpen.value;
};

watch(isOpen, async () => {
	await nextTick();
	setTimeout(() => {
		generateGridHashMarkBounds();
	}, 300)
});
</script>
